import { useEffect, useState } from 'react';

interface ArticleTocProps {
  headings: string[];
}

export default function ArticleToc({ headings }: ArticleTocProps) {
  const [activeId, setActiveId] = useState('section-0');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) {
          setActiveId(visible[0].target.id);
        }
      },
      { rootMargin: '-120px 0px -60% 0px', threshold: 0 },
    );

    headings.forEach((_, index) => {
      const el = document.getElementById(`section-${index}`);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [headings]);

  const handleClick = (index: number) => {
    const el = document.getElementById(`section-${index}`);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 96;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <nav aria-label="文章目录" className="rounded-lg border border-background-200/70 bg-background-50 p-5">
      <h3 className="font-heading flex items-center gap-2 text-sm font-bold text-foreground-950">
        <i className="ri-list-check-2 text-primary-500" />
        本文目录
      </h3>
      <ul className="mt-4 space-y-2.5">
        {headings.map((heading, index) => {
          const active = activeId === `section-${index}`;
          return (
            <li key={heading}>
              <button
                type="button"
                onClick={() => handleClick(index)}
                className={`text-left text-xs leading-relaxed transition-colors ${
                  active ? 'font-medium text-primary-700' : 'text-foreground-600 hover:text-foreground-950'
                }`}
              >
                {heading}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}